/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns, selectorNs, sharedNs;

  ns = window.nspace("ccc.viz.map.views");
  selectorNs = window.nspace("ccc.viz.selectors");
  sharedNs = window.nspace("ccc.viz.shared");

  ns.SelectorsView = sharedNs.views.SelectorsView.extend({
    initializeView: function() {
      // Expose this (presumably one-and-only) instance globally so that other components
      // can call "public" methods and get selector information, such as for building data summaries.
      // TODO: What's a better way to architect this?
      ns.instances = { SelectorsView: this };

      this.model.on("change", this.updateDataSummary);
    },

    initializeSelectors: function() {
      this.allSelectors = [
        // Breakdown
        (this.breakdownSelectorView = new selectorNs.BreakdownSelectorView({
          model: this.model
        })),
        // Location Type
        (this.locationTypeSelectorView = new selectorNs.LocationTypeSelectorView(
          {
            model: this.model
          }
        )),
        // Data Type
        (this.dataTypeSelectorView = new selectorNs.DataTypeSelectorView({
          model: this.model,
          getSelectorInfoFunc: this.getSelectorInfoOrThrow
        })),
        // TimeFrame
        (this.timeFrameSelectorView = new selectorNs.TimeFrameSelectorView({
          model: this.model,
          getSelectorInfoFunc: this.getSelectorInfoOrThrow
        }))
      ];
    },

    getIndicatorSpecificSelectors: function() {
      return [
        this.locationTypeSelectorView,
        this.dataTypeSelectorView,
        this.timeFrameSelectorView
      ];
    },

    updateDataSummary: function() {
      $("#data-summary").text(this.getDataSummary());
    }
  });
})(jQuery, _);
